import React, { memo } from 'react';

import TextData, { WidgetTextContent } from 'domain/entity/widgets/TextData';
import { StyledBody, StyledHeaderText, StyledWidgetTextWrapper } from 'adapter/in/common/components/widgets/Text/style';
import { ALIGN_TEXT } from 'adapter/in/common/widget/options';
import { checkMemoChanges } from 'adapter/in/common/components/widgets/common/checkRedraw';

type WidgetTextProps = {
    data: TextData;
    isLoading: boolean;
    height: number;
};

const WidgetText = (props: WidgetTextProps) => {
    const { data, isLoading, height } = props;
    const header = isLoading ? new WidgetTextContent('Header of widget', ALIGN_TEXT.START) : data.header;
    const body = isLoading ? new WidgetTextContent('Body of widget', ALIGN_TEXT.START) : data.body;
    return (
        <StyledWidgetTextWrapper data-testid='text-widget'>
            {header.text !== '' && <StyledHeaderText $alignText={header.alignText}>{header.text}</StyledHeaderText>}
            {body.text !== '' && (
                <StyledBody $alignText={body.alignText} $heightValue={height} $hasHeader={header.text !== ''}>
                    {body.text}
                </StyledBody>
            )}
        </StyledWidgetTextWrapper>
    );
};

export default memo(WidgetText, checkMemoChanges);
